import { render } from "./DeviceGroupForm.vue?vue&type=template&id=3c19b72a&scoped=true"
import script from "./DeviceGroupForm.vue?vue&type=script&lang=js"
export * from "./DeviceGroupForm.vue?vue&type=script&lang=js"

import "./DeviceGroupForm.vue?vue&type=style&index=0&id=3c19b72a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3c19b72a"

export default script